import { Button, Dialog, DialogBody, DialogTitle } from "@/components/atoms";
import { ArrowRightCircleIcon, XMarkIcon } from "@heroicons/react/20/solid";
import Link from "next/link";

interface ModalProps {
  handleOpen?: () => void;
  handleClose: () => void;
  isOpen: boolean;
}

export default function CreateWalletModal({ handleClose, isOpen }: ModalProps) {
  return (
    <>
      <Dialog size="5xl" centered open={isOpen} onClose={handleClose}>
        <DialogTitle className="flex justify-between items-center">
          Wallet
          <XMarkIcon className="h-6 w-6 cursor-pointer" onClick={handleClose} />
        </DialogTitle>
        <DialogBody className="py-14 px-16 flex flex-col space-y-6 justify-center items-center">
          <p className="font-semibold text-center">
            You need your wallet <br />
            to proceed with this payment
          </p>
          <Link href="/procure/wallet/kyc/personal-details">
            <Button full>
              Create Wallet
              <ArrowRightCircleIcon />
            </Button>
          </Link>
        </DialogBody>
      </Dialog>
    </>
  );
}
